var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse2, _mask, _path9, _path10, _path11, _path12, _rect, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 220,
    viewBox: "0 0 280 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.744 39.6685C197.964 43.1685 221.904 41.4885 233.384 50.5885C244.864 59.6885 243.884 79.5685 245.984 100.709C248.224 121.849 253.404 144.109 242.624 154.329C231.704 164.409 204.544 162.169 185.224 167.349C165.904 172.669 154.144 185.269 141.964 186.109C129.784 187.089 116.904 176.449 105.284 166.789C93.664 157.129 83.164 148.449 68.464 137.389C53.764 126.329 34.724 112.889 30.804 97.2085C26.884 81.3885 37.944 63.4685 49.984 47.7885C62.164 32.2485 75.324 19.0885 91.004 14.7485C106.544 10.4085 124.604 14.7485 138.744 21.1885C153.024 27.6285 163.524 36.3085 180.744 39.6685Z",
    fill: "#EBF4F7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.523,
    cy: 192.448,
    rx: 36,
    ry: 5,
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.29 78.9175C110.422 94.0244 140.158 118.031 140.158 118.031C140.158 118.031 139.683 105.57 143.714 99.3179C149.866 89.7751 163.868 92.1644 170.626 88.3179C181.937 81.8803 183.159 70.9523 180.201 59.4482C177.311 48.2093 159.663 42.6721 150.586 40.5377C148.767 40.1101 147.477 42.2851 148.527 43.8312C151.105 47.6311 154.237 53.3119 154.201 58.4482C154.106 72.2016 121.27 66.097 116.29 78.9175Z",
    fill: "#E76058",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.523 146.448C165.523 146.448 174.237 134.023 182.523 137.948C192.023 142.448 192.523 152.948 188.023 160.448C183.523 167.948 165.523 183.948 165.523 183.948",
    stroke: "#215585",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.523 128.448H168.523V185.448C168.523 189.314 165.389 192.448 161.523 192.448H113.523C109.657 192.448 106.523 189.314 106.523 185.448V128.448Z",
    fill: "#F7F7F7",
    stroke: "#215585",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.523 146.448C165.523 146.448 174.237 134.023 182.523 137.948C192.023 142.448 192.523 152.948 188.023 160.448C183.523 167.948 165.523 183.948 165.523 183.948",
    stroke: "#F8F8FA",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.523 129.448C101.523 131.657 103.314 133.448 105.523 133.448H169.523C171.733 133.448 173.523 131.657 173.523 129.448C173.523 127.239 171.733 125.448 169.523 125.448H105.523C103.314 125.448 101.523 127.239 101.523 129.448Z",
    fill: "#215585"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.523 133.448H120.523V175.448C120.523 177.657 118.733 179.448 116.523 179.448C114.314 179.448 112.523 177.657 112.523 175.448V133.448Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.523 125.448H118.523V133.448H110.523V125.448Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 199.06,
    rx: 38.5,
    ry: 4.94002,
    fill: "#F7F7F7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_1068_10912",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 194.94C71 197.668 73.2117 199.88 75.94 199.88L141 199.88L147.622 195.791C148.255 195.4 148.255 194.48 147.622 194.089L141 190L75.94 190C73.2117 190 71 192.212 71 194.94Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 194.94C71 197.668 73.2117 199.88 75.94 199.88L141 199.88L147.622 195.791C148.255 195.4 148.255 194.48 147.622 194.089L141 190L75.94 190C73.2117 190 71 192.212 71 194.94Z",
    fill: "#F8F8FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141 199.88L141 201.88L141.568 201.88L142.051 201.582L141 199.88ZM147.622 195.791L148.673 197.493L148.673 197.493L147.622 195.791ZM147.622 194.089L148.673 192.388L148.673 192.388L147.622 194.089ZM141 190L142.051 188.298L141.568 188L141 188L141 190ZM75.94 197.88C74.3163 197.88 73 196.564 73 194.94L69 194.94C69 198.773 72.1071 201.88 75.94 201.88L75.94 197.88ZM141 197.88L75.94 197.88L75.94 201.88L141 201.88L141 197.88ZM142.051 201.582L148.673 197.493L146.571 194.089L139.949 198.178L142.051 201.582ZM148.673 197.493C150.571 196.32 150.571 193.56 148.673 192.388L146.571 195.791C145.938 195.4 145.938 194.48 146.571 194.089L148.673 197.493ZM148.673 192.388L142.051 188.298L139.949 191.702L146.571 195.791L148.673 192.388ZM75.94 192L141 192L141 188L75.94 188L75.94 192ZM73 194.94C73 193.316 74.3163 192 75.94 192L75.94 188C72.1072 188 69 191.107 69 194.94L73 194.94Z",
    fill: "#F8D177",
    mask: "url(#path-11-inside-1_1068_10912)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145 192.47L147.622 194.089C148.255 194.48 148.255 195.4 147.622 195.791L145 197.41L144 198.028L144 191.853L145 192.47Z",
    fill: "#F8D177"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140 198.892C140 198.398 139 198.006 139 196.915C139 195.823 141 195.434 141 194.939C141 194.443 139 194.054 139 192.963C139 191.871 140 191.976 140 190.987",
    stroke: "#F8D177"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 198.892,
    width: 7.90403,
    height: 2,
    transform: "rotate(-90 77 198.892)",
    fill: "#F8D177"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 194.94L77 194.94",
    stroke: "#F8D177",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.26ebb49ce5d5f516aafa2d471aad9783.svg";
export { ForwardRef as ReactComponent };